/**
 * Permission Resolution Service - B2C Merchant Portal
 *
 * Fetches the user's full permission snapshot from the IAM backend.
 */

import axios from 'axios';
import { normaliseSnapshot } from '../utils/permissions';

/** Endpoint on the IAM service for V2 permission resolution. */
const RESOLVE_ENDPOINT = '/v2/iam/permissions/resolve';

/**
 * Fetches the authenticated user's full permission snapshot.
 *
 * Uses a standalone axios call to the IAM base URL (not the POCAS-targeted
 * API instance) since this endpoint lives on the IAM service.
 *
 * @returns {Promise<Object>} Normalised PermissionSnapshot in camelCase.
 */
export async function fetchPermissionSnapshot() {
  const token = localStorage.getItem('authToken');
  if (!token) {
    throw new Error('No auth token available');
  }

  const baseUrl = process.env.REACT_APP_IAM_BASE_URL || '';
  const response = await axios.get(`${baseUrl}${RESOLVE_ENDPOINT}`, {
    headers: {
      Authorization: token, // Raw token - no Bearer prefix (standing rule)
      Accept: 'application/json',
    },
    timeout: 15000,
  });

  return normaliseSnapshot(response.data);
}
